import type { OwaDate } from '../schema';
import tz from './tz';

/**
 * Produces a time zone aware wrapper around a UTC-modification function
 * that operates on date values, ie, years, months, weeks and days.
 */
export default (
    fn: (time: number, amount: number) => Date
): ((date: OwaDate, amount: number) => OwaDate) => tz(fn, false);
